import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.css';

class Body extends Component {
	render() {
		const { children } = this.props;
		return <div className="window-layout-body">{children}</div>;
	}
}

Body.propTypes = {
	children: PropTypes.node
};

export default Body;
